import { render, staticRenderFns } from "./ESorganizationDetail.vue?vue&type=template&id=40539047&scoped=true"
import script from "./ESorganizationDetail.vue?vue&type=script&lang=js"
export * from "./ESorganizationDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40539047",
  null
  
)

export default component.exports